import { mediaItems } from '@/mocks/homeData';

const mediaImages = [
  'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20interior%20with%20flowing%20silk%20curtains%20and%20warm%20lantern%20light%2C%20soft%20golden%20hour%20glow%2C%20ethereal%20dreamy%20atmosphere%2C%20cinematic%20composition%2C%20traditional%20architecture%20details%2C%20jade%20and%20gold%20color%20scheme%2C%20elegant%20mood&width=800&height=600&seq=media-01&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Modern%20city%20skyline%20at%20twilight%20through%20rain%20streaked%20window%2C%20cozy%20apartment%20interior%20with%20warm%20lamp%20light%2C%20intimate%20urban%20atmosphere%2C%20soft%20bokeh%20lights%2C%20contemporary%20romance%20mood%2C%20warm%20neutral%20tones%2C%20cinematic%20depth&width=800&height=600&seq=media-02&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Moody%20detective%20office%20with%20scattered%20case%20files%20and%20vintage%20desk%20lamp%2C%20dramatic%20shadows%20and%20light%2C%20film%20noir%20atmosphere%2C%20mysterious%20and%20intense%2C%20amber%20and%20sepia%20tones%2C%20cinematic%20suspense%20aesthetic&width=800&height=600&seq=media-03&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Sunlit%20school%20corridor%20with%20cherry%20blossoms%20outside%20the%20window%2C%20warm%20spring%20light%20streaming%20through%2C%20nostalgic%20youthful%20atmosphere%2C%20soft%20pastel%20tones%20with%20golden%20highlights%2C%20dreamy%20and%20hopeful%20mood%2C%20cinematic%20wide%20shot&width=800&height=600&seq=media-04&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Epic%20historical%20battlefield%20at%20golden%20hour%2C%20sweeping%20landscape%20with%20dramatic%20clouds%2C%20heroic%20lone%20figure%20silhouette%20against%20warm%20sky%2C%20grand%20cinematic%20scale%2C%20rich%20amber%20and%20bronze%20tones%2C%20breathtaking%20composition&width=800&height=600&seq=media-05&orientation=landscape',
];

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-14 md:py-20 bg-background-100 scroll-mt-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-4xl font-heading text-foreground-900 mb-3">
              热播精选
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
              本周最受好评的电视剧，每一部都值得追
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
            {mediaItems.map((item, index) => (
              <div
                key={item.title}
                className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-300 transition-all duration-200 cursor-pointer"
              >
                <div className="relative aspect-[4/3] overflow-hidden bg-background-200">
                  <img
                    src={mediaImages[index]}
                    alt={`${item.title} - ${item.subtitle}`}
                    title={`${item.title} - ${item.subtitle}`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-2 right-2 px-2 py-0.5 rounded-md bg-accent-500 text-background-50 text-xs font-medium whitespace-nowrap">
                    {item.tag}
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="text-sm md:text-base font-heading text-foreground-900 mb-1">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-400 mb-2">{item.subtitle}</p>
                  <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                    {item.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}